import React from 'react'
import classes from './MyEmployees.module.css'
import { 
    Grid, Text, Input, InputGroup, InputLeftAddon, GridItem, Button, Divider,
    Table, Thead, Th, Td, Tr,
    Tbody,
    Flex
} from '@chakra-ui/react'
import { SearchIcon } from '@chakra-ui/icons'

function MyEmployees() {
    return (
        <Grid className={classes.container}>
            <Grid className={classes.filters}>
                <GridItem colSpan={2}>
                    <Button>
                        Обновить
                    </Button>
                </GridItem>

                <InputGroup>
                    <InputLeftAddon>от</InputLeftAddon>
                    <Input
                        type='date'
                    />
                </InputGroup>
                <InputGroup>
                    <InputLeftAddon>до</InputLeftAddon>
                    <Input
                        type='date'
                    />
                </InputGroup>

                <GridItem colSpan={2}>
                    <Divider />
                </GridItem>

                <GridItem colSpan={2}>
                    <InputGroup>
                        <InputLeftAddon><SearchIcon/></InputLeftAddon>
                        <Input
                            placeholder='Фильтр по имени или почте'
                        />
                    </InputGroup>
                </GridItem>
            </Grid>

            <div className={classes.table}>
                <Table>
                    <Thead>
                        <Tr>
                            <Th>Имя</Th>
                            <Th>Роль</Th>
                            <Th>ГУ куратора</Th>
                            <Th>Средний % проведенного онбординга</Th>
                            <Th>Средний % просмотренности занятий</Th>
                            <Th>Средний % сдаваемости ДЗ</Th>
                            <Th></Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        <Tr>
                            <Td>Имя</Td>
                            <Td>Роль</Td>
                            <Td>ГУ куратора</Td>
                            <Td>100</Td>
                            <Td>100</Td>
                            <Td>100</Td>
                            <Td>
                                <Flex gap="calc(var(--default-gap) / 2)">
                                    <Button size='sm'>Изменить роль</Button>
                                    <Button size='sm'>Удалить куратора</Button>
                                </Flex>
                            </Td>
                        </Tr>
                    </Tbody>
                </Table>
            </div>
        </Grid>
    )
}

export default MyEmployees
